module.exports = __webpack_public_path__ + "static/media/tablet.921da476.svg";